import React, { Fragment, useState, useEffect, useRef } from 'react';
import { ToastProvider, useToasts } from 'react-toast-notifications';
import {
  Container,
  Row,
  Col,
  FormGroup,
  ButtonGroup,
  Alert,
} from 'react-bootstrap';
import Card from 'components/Card/Card.jsx';
import Button from '../../components/CustomButton/CustomButton';
import language from '../../config/es';
import AsyncSelect from 'react-select/async';
import Select from 'react-select';
import DataTable from 'react-data-table-component';
import app from '../../config/application';
import LabelChargeData from '../../components/Label/labelChargeData';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
//redux cliente
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../redux/store/hooks';
import {
  findData,
  getCountData,
  getTotal,
  clean,
  getPayments,
} from '../../redux/monitor.duck';
import { findByConcept, getValuByConcept } from '../../redux/type.duck';
import { findSocieties } from '../../redux/society.duck';
import { findBySocieties } from '../../redux/collectingEntity.duck';
//Session user
import SessionConfig from '../../config/session_config';
import dictionary from '../../config/dictionary';
import PaymentDetailTable from './PaymentDetailTable';
import DateRangeFilter from './shared/DateRangeFilter';
import { createIncomeFilterHandlers } from './shared/incomeFilterHandlers';
import { getServerTableProps } from './shared/serverTableProps';
import {
  buildTraceColumn,
  buildEntityColumn,
  buildClientColumn,
  buildChannelColumn,
  buildTotalColumn,
  buildStateColumn,
  buildDateColumn,
} from './shared/incomeColumns';

// Clase css para la traza y el total segun el estado
const getTraceClassName = (statusType) => {
  if (statusType === null) {
    return 'text-primary ';
  }
  return statusType.name.toLowerCase().includes('anulado')
    ? 'text-uppercase '
    : 'text-primary  ';
};
// Clase css para el estado del pago
const getStatusClassName = (statusType) => {
  if (statusType === null) {
    return '';
  }
  return statusType.name.toLowerCase().includes('anulado')
    ? 'text-uppercase small-font'
    : 'text-primary text-uppercase small-font';
};
function findArrayElementByTitle(array, value) {
  return array.find((element) => {
    return element.value === value;
  });
}

const ExpandedComponent = ({ data }) => (
  <PaymentDetailTable
    data={data}
    textSizeClass="small-font"
    amountWidth="150px"
    formatAmount={(amount) => amount.toLocaleString('en')}
  />
);

// Etiqueta de cliente bodega
const renderBodegaBadge = (row) =>
  row.identityClientCode.groupCode ===
  dictionary.configApp.type.typeClientBodega ? (
    <div className="badge bg-warning">BODEGA</div>
  ) : null;

// Columnas de la tabla del monitor de pagos
const buildMonitorColumns = (options, optionsTime) => [
  buildTraceColumn(getTraceClassName),
  buildEntityColumn(
    '200px',
    'text-uppercase small-font ',
    ' text-uppercase small badge bg-secondary '
  ),
  buildClientColumn('200px', ' text-uppercase small-font ', renderBodegaBadge),
  {
    name: language.messages.monitor.sap,
    sortable: false,
    wrap: true,
    minWidth: '90px',
    cell: (row) => (
      <span>
        <div className=" text-uppercase small-font">
          {row.identityClientCode.code}
        </div>
      </span>
    ),
  },
  buildChannelColumn('text-uppercase small-font '),
  buildTotalColumn('130px', getTraceClassName, 2),
  buildStateColumn(getStatusClassName),
  buildDateColumn(options, optionsTime),
];

const Monitor = () => {
  const ref = useRef();
  const { addToast } = useToasts();
  const dispatch = useAppDispatch();
  const [date, setDate] = useState({
    dateIni: new Date(),
    dateEnd: new Date(),
    dateFIni: new Date(),
    dateFEnd: new Date(),
  });
  const [isVisible, setIsVisible] = useState(false);
  const [loadingSociety, setLoadingSociety] = useState(false);
  const [loadingEntity, setLoadingEntity] = useState(true);
  const [typeClient, setTypeClient] = useState({ value: 0, label: '' });
  let [paymentsData] = useState([]);

  const [data, setData] = useState({
    salesArea: [],
    payments: [],
    states: [],
    stateFind: [],
    societies: [],
    entities: [],
    columns: [],
    customerTypes: [],
    pendingData: false,
    showloadingStates: false,
    loadingTypes: true,
    enable: true,
    page: 0,
    size: 10,
    totalRows: 0,
    options: { year: 'numeric', month: 'numeric', day: 'numeric' },
    optionsTime: { hour: 'numeric', minute: 'numeric' },
    error: '',
    filterCodeClient: '',
    client: { value: 0, label: '' },
    society: { value: 0, label: '' },
    collectingEntity: { label: '', value: 0, error: '' },
    state: { value: 0, label: language.messages.lblAll },
    auth: JSON.parse(sessionStorage.getItem('user')),
  });
  paymentsData = useSelector((store) => store.monitorReducer.payments);
  const totalP = useSelector((store) => store.monitorReducer.amount);
  data.payments = useSelector((store) => store.monitorReducer.monitorData);
  data.totalRows = useSelector((store) => store.monitorReducer.totalRows);
  data.error = useSelector((store) => store.monitorReducer.noPermittedMonitor);

  data.clients = useSelector((store) => store.clientReducer.clients);
  data.states = useSelector((store) => store.typeReducer.types);
  data.loadingTypes = useSelector((store) => store.typeReducer.loading);
  data.customerTypes = useSelector((store) => store.typeReducer.lsType);
  data.societies = useSelector((store) => store.societyReducer.societies);
  data.entities = useSelector(
    (store) => store.collectingEntityReducer.cEntities
  );
  const {
    refreshState,
    updateState,
    viewNotification,
    messageError,
    changeClient,
    handlePerRowsChange,
    handlePageChange,
    onChangeDate,
    onChangeDateEnd,
    promiseOptions,
  } = createIncomeFilterHandlers({
    data,
    setData,
    date,
    setDate,
    dispatch,
    addToast,
    search: () => search(),
  });

  //ciclo de vida ---------------------------------------------------
  useEffect(() => {
    data.client = { value: 0, label: '' };
    data.state = { value: 0, label: language.messages.lblAll };
    refreshState();
    setTypeClient({ value: 0, label: '' });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVisible]);
  useEffect(() => {
    data.pendingData = false;
    data.enable = true;
    refreshState();
    if (paymentsData.length > 0) {
      buildXls();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentsData]);

  useEffect(() => {
    messageError();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.error]);
  useEffect(() => {
    void loadSocieties();
    void loadDataStates();
    initTable();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    ref.current.onRefreshCurrentSession();
  }, [data]);
  useEffect(() => {
    let itemAll = { value: 0, label: language.messages.monitor.lblAll };
    data.state = { value: 0, label: language.messages.monitor.lblAll };
    data.states.unshift(itemAll);
    data.showloadingStates = true;
    updateState(true, 'showloadingStates');
    updateState(itemAll, 'state');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.states]);

  useEffect(() => {
    data.collectingEntity = { value: 0, label: '' };
    void loadEntities();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.society]);
  useEffect(() => {
    setLoadingEntity(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.entities]);
  //handlers ---------------------------------------------------
  const loadSocieties = async () => {
    await dispatch(findSocieties(data.auth.id.user.userId));
    setLoadingSociety(true);
  };

  const updateSelect = (value, id) => {
    switch (id) {
      case 'state':
        const todos = findArrayElementByTitle(data.states, 0);
        data.stateFind = todos;
        if (todos === undefined) {
          let itemAll = { value: 0, label: language.messages.monitor.lblAll };
          data.states.push(itemAll);
        }
        data.state = value;
        break;
      case 'society':
        data.society = value;
        setLoadingEntity(false);
        break;
      case 'entity':
        data.collectingEntity = !value
          ? { value: 0, label: '', error: '' }
          : value;
        break;
      default:
        break;
    }
    //updateState(value, 'state');
    refreshState();
  };
  //funciones ---------------------------------------------------
  const loadEntities = async () => {
    data.showloadingEntity = false;
    await dispatch(findBySocieties(data.society.value));
    updateState(true, 'showloadingEntity');
  };

  const search = async () => {
    if (data.society.value === 0) {
      viewNotification(language.messages.msmSociety, 'error');
    } else {
      await dispatch(clean());
      data.pendingData = true;
      data.enable = false;
      date.dateFIni = date.dateIni;
      date.dateFEnd = date.dateEnd;
      data.filterCodeClient = data.client.value;
      refreshState();
      await loadCount();
      await loadData();
    }
  };

  const loadDataStates = async () => {
    await dispatch(findByConcept(app.data.types.statusPayment));
    await dispatch(getValuByConcept(app.data.types.customerType));
  };

  // Filtro de busqueda de pagos
  const buildFilterJson = () => ({
    user_id: data.auth.id.user.userId,
    dateStart: date.dateFIni,
    dateEnd: date.dateFEnd,
    statusPayment: data.state.value,
    documentOrCodeClient: data.filterCodeClient,
    quantity: data.size,
    page: data.page,
    societyCode: data.society.value,
    entity: data.collectingEntity.value,
    codeTypeCustomer: typeClient.value,
  });
  const loadData = async () => {
    let json = buildFilterJson();
    let jsonD = { ...json };

    dispatch(getTotal(jsonD));
    await dispatch(findData(json, data.auth.id.user.username));
    data.pendingData = false;
    data.enable = true;
    refreshState();
  };
  const loadCount = async () => {
    let json = buildFilterJson();
    await dispatch(getCountData(json, data.auth.id.user.username));
  };
  const conditionalRowStyles = [
    {
      when: (row) => row.statusType.name.toLowerCase().includes('anulado'),
      style: {
        backgroundColor: 'rgb(220, 53, 69)',
        color: 'white',
        '&:hover': {
          cursor: 'pointer',
        },
      },
    },
  ];
  const initTable = () => {
    data.columns = buildMonitorColumns(data.options, data.optionsTime);
    updateState(data.columns, 'columns');
  };
  const exportXls = async () => {
    await dispatch(clean());
    data.enable = false;
    date.dateFIni = date.dateIni;
    date.dateFEnd = date.dateEnd;
    data.filterCodeClient = data.client.value;
    data.pendingData = true;

    refreshState();
    let json = buildFilterJson();

    dispatch(getPayments(json, data.auth.id.user.username));
  };
  const buildXls = () => {
    const XLSX = require('xlsx');
    const ws = XLSX.utils.json_to_sheet(paymentsData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Datos');
    //generando archivo
    XLSX.writeFile(
      wb,
      'RESUMEN DE PAGOS ' +
        data.society.value +
        ' DEL ' +
        new Date(date.dateFIni).toLocaleDateString('es-ES', data.options) +
        ' AL ' +
        new Date(date.dateFEnd).toLocaleDateString('es-ES', data.options) +
        '.xlsx'
    );
  };
  //render----------------------------------------------------------
  return (
    <Fragment>
      <SessionConfig ref={ref} />
      <div className="main-content">
        <Container fluid={true}>
          <Row>
            <Col md={12}>
              <Card
                icono=" fa  fa-filter"
                title={language.messages.title_filter}
                content={
                  <Fragment>
                    <div className="form-vertical">
                      <Row>
                        <DateRangeFilter
                          onChangeDate={onChangeDate}
                          onChangeDateEnd={onChangeDateEnd}
                        />
                        <Col sm={5} lg={5} xl={3}>
                          <h6 className="title">
                            {language.messages.society.title_society}
                          </h6>
                          <LabelChargeData showloading={loadingSociety} />
                          <FormGroup>
                            <Select classNamePrefix="ui-select"
                              placeholder={language.messages.lblSingleSelect}
                              name="society"
                              options={data.societies}
                              className="text-uppercase small-font"
                              value={{
                                value: data.society.value,
                                label: data.society.label,
                              }}
                              onChange={(value) => {
                                updateSelect(value, 'society');
                              }}
                            />
                          </FormGroup>
                        </Col>
                        <Col sm={5} lg={5} xl={4}>
                          <h6 className="title">
                            {language.messages.titleCEntityForm}
                          </h6>
                          <LabelChargeData showloading={loadingEntity} />
                          <FormGroup>
                            <Select classNamePrefix="ui-select"
                              isClearable={true}
                              className="text-uppercase small-font "
                              isDisabled={!loadingEntity}
                              placeholder={language.messages.lblSingleSelect}
                              name="entity"
                              options={data.entities}
                              value={{
                                value: data.collectingEntity.value,
                                label: data.collectingEntity.label,
                              }}
                              onChange={(value) => {
                                updateSelect(value, 'entity');
                              }}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        {isVisible ? (
                          <Fragment>
                            <Col sm={4} lg={4} xl={3}>
                              <h6 className="title">
                                {language.messages.monitor.lblState}
                              </h6>
                              <LabelChargeData
                                showloading={data.showloadingStates}
                              />
                              <FormGroup>
                                <Select classNamePrefix="ui-select"
                                maxMenuHeight={150}
                                  placeholder={
                                    language.messages.lblSingleSelect
                                  }
                                  name="state"
                                  options={data.states}
                                  className="text-uppercase small-font"
                                  value={{
                                    value: data.state.value,
                                    label: data.state.label,
                                  }}
                                  onChange={(value) => {
                                    updateSelect(value, 'state');
                                  }}
                                />
                              </FormGroup>
                            </Col>
                            <Col sm={6} lg={6} xl={4}>
                              <h6 className="title">
                                {language.messages.monitor.lblClient}
                              </h6>

                              <FormGroup>
                                <AsyncSelect classNamePrefix="ui-select"
                                  maxMenuHeight={150}
                                  cacheOptions
                                  className="small-font text-uppercase"
                                  isDisabled={data.society.value === 0}
                                  placeholder={
                                    language.messages.lblSingleSelect
                                  }
                                  name="client"
                                  loadOptions={promiseOptions}
                                  isClearable={true}
                                  value={{
                                    value: data.client.value,
                                    label: data.client.label,
                                  }}
                                  onChange={(value) => {
                                    changeClient(value);
                                  }}
                                />
                              </FormGroup>
                            </Col>
                            <Col sm={4} lg={4} xl={3}>
                              <h6 className="title">
                                {language.messages.monitor.lblCustomerType}
                              </h6>
                              <LabelChargeData
                                showloading={!data.loadingTypes}
                              />
                              <FormGroup>
                                <Select classNamePrefix="ui-select"
                                  isClearable={true}
                                  placeholder={
                                    language.messages.lblSingleSelect
                                  }
                                  name="typeCustomer"
                                  options={data.customerTypes}
                                  className="text-uppercase small-font"
                                  value={{
                                    value: typeClient.value,
                                    label: typeClient.label,
                                  }}
                                  onChange={(value) => {
                                    setTypeClient(
                                      !value ? { value: 0, label: '' } : value
                                    );
                                  }}
                                />
                              </FormGroup>
                            </Col>
                          </Fragment>
                        ) : (
                          ''
                        )}
                      </Row>
                      <Row>
                        <Col className="d-flex justify-content-center " xl={12}>
                          <h6 className="title">
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          </h6>
                          <ButtonGroup className="d-flex">
                            <Button
                              disabled={!data.enable}
                              info
                              fill
                              size="large"
                              type="button"
                              onClick={search}
                            >
                              <i className="fa fa-search"></i>{' '}
                              {language.messages.monitor.lblSearch}
                            </Button>
                            <Button
                              disabled={!data.enable}
                              success
                              fill
                              size="large"
                              type="button"
                              onClick={exportXls}
                            >
                              <i className="fa fa-file-excel-o"></i>{' '}
                              {language.messages.monitor.export}
                            </Button>
                          </ButtonGroup>
                          <FormControlLabel
                            control={
                              <Switch
                                size="small"
                                checked={isVisible}
                                name="filterAdvance"
                                onChange={(value) => {
                                  setIsVisible(value.target.checked);
                                }}
                              />
                            }
                            label={
                              language.messages.history.filterAdvanceSearch
                            }
                            labelPlacement="top"
                          />
                        </Col>
                      </Row>
                    </div>
                    <hr />
                    <Alert className="alert-primary ">
                      <strong className="text-danger small">
                        {language.messages.monitor.lblNote}
                      </strong>
                      <span className="small-font">
                        {' '}
                        {language.messages.monitor.msmExport}
                      </span>
                    </Alert>
                    <div className="fresh-datatables">
                      <DataTable
                        conditionalRowStyles={conditionalRowStyles}
                        title={
                          <Row>
                            <Col lg={9}>
                              <span>
                                {language.messages.monitor.title_monitor}
                              </span>
                            </Col>
                            {totalP.total === null ||
                            totalP.total === undefined ||
                            totalP.total === 0 ||
                            data.pendingData ? (
                              ''
                            ) : (
                              <Col lg={3} className="text-end">
                                <span className="badge bg-warning">
                                  {language.messages.monitor.lblTotal}: &nbsp;
                                  {totalP.total.toLocaleString('en')}
                                  &nbsp;
                                  {totalP.coin.name} {totalP.coin.code}
                                </span>
                              </Col>
                            )}
                          </Row>
                        }
                        data={data.payments}
                        columns={data.columns}
                        {...getServerTableProps({
                          data,
                          scrollHeight: '800px',
                          onChangeRowsPerPage: handlePerRowsChange,
                          onChangePage: handlePageChange,
                        })}
                        expandableRows
                        expandableRowsComponent={ExpandedComponent}
                      />
                    </div>
                  </Fragment>
                }
              />
            </Col>
          </Row>
        </Container>
      </div>
    </Fragment>
  );
};

const App = () => (
  <ToastProvider>
    <Monitor />
  </ToastProvider>
);
export default App;
